import React, { useContext, useState } from "react"
import { storageData } from "services/Services"
import { AddressChangeContext } from "./AddressChangeContext";

export const NewAddressContext = React.createContext()

const useModal = () => {
    const [modalTitle, setModalTitle] = useState("");
    const [modalMsg, setModalMsg] = useState("");
    const [showModal, setShowModal] = useState(false);

    const openModal = (title, message) => {
        setModalTitle(title);
        setModalMsg(message);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return {
        modalTitle,
        modalMsg,
        showModal,
        openModal,
        closeModal,
    };
};

export const NewAddressContextComp = ({ children }) => {
    const addressChangeContext = useContext(AddressChangeContext)
    // Fields for new address
    const initialNewAddress = {
        componentTracker: "",
        dateMoved: addressChangeContext.getTodaysDate(),
        requestedEffDate: addressChangeContext.getTodaysDate(true),
        homeAddress: "",
        aptNumber: "",
        city: "",
        state: "",
        zip: "",
        garaged: "",
        county: "",
        regionCd: "",
        regionISOCd: "",
        verificationHash: "",
        latitude: "",
        longitude: "",
        dpv: "",
        dpvDesc: "",
        dpvNotes: "",
        dpvNotesDesc: "",
        barcodeDigits: "",
        carrierRoute: "",
        congressCode: "",
        countyCode: "",
        block: "",
        tract: "",
        decennialCensusKey: ""
    }

    const [newAddress, setNewAddress] = useState("requestedEffDate" in addressChangeContext?.addressChangeClass?.newAddress ?
        addressChangeContext?.addressChangeClass?.newAddress :
        initialNewAddress
    );
    const currResidenceBill = storageData.getItem("currResidenceBill")
    const policyStreetAddress = JSON.parse(currResidenceBill).address1
    const modal = useModal()

    // Retrieves Form Values
    const newAddressCallback = (key, value) => {
        var newAddressCopy = newAddress
        newAddressCopy[key] = value
        setNewAddress({ ...newAddress, ...newAddressCopy });
    }

    return (
        <NewAddressContext.Provider
            value={{
                newAddress, setNewAddress,
                initialNewAddress,
                newAddressCallback,
                modal, policyStreetAddress
            }}>
            {children}
        </NewAddressContext.Provider>
    )
}